import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import coverImg from 'images/cover.jpg';
import competenceImg from 'images/picto/competence.png';
import reliabilityImg from 'images/picto/reliability.png';
import richImg from 'images/picto/rich.png';
import mainTextImg from 'images/main_text.jpeg';
import i18n from 'i18next';

const Cover = styled.div`
	background-image: url(${coverImg});
	background-position: center 40%;
	background-size: cover;
	padding: 40px 0;
	width: 100vw;
	position: relative;
	display: flex;
	justify-content: center;

	&:before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 70, 133, 0.5);
		z-index: 1;
	}

	@media (min-width: 1280px) {
		padding: 120px 0;
	}

	> div {
		display: flex;
		flex-direction: column;
		gap: 10px;
		z-index: 2;

		h1 {
			color: white;
			text-transform: uppercase;
			margin-bottom: 10px;
		}

		h2 {
			color: white;
		}
	}
`;

const Advantages = styled.div`
	width: 100vw;
	padding: 40px 0;
	display: flex;
	justify-content: center;
	background-color: #D3EFFF;

	h1, h3 {
		color: ${props => props.theme.darkBlue};
	}

	h3 {
		text-transform: uppercase;
	}

	> div {
		display: flex;
		flex-direction: column;
		align-items: stretch;
		gap: 20px;

		> div {
			display: flex;
			flex-direction: column;
			gap: 20px;
			position: relative;

			@media (min-width: 1280px) {
				flex-direction: row;
			}

			> div {
				display: flex;
				flex-direction: column;
				gap: 20px;

				@media (min-width: 1280px) {
					width: calc((100% - 40px) / 3);
				}

				img {
					width: 60px;
					height: 60px;
					object-fit: cover;
					object-position: center center;
				}

				p {
					margin-top: -10px;
				}
			}
		}
	}
`;

const MainText = styled.div`
	margin: 40px 0;
	display: flex;
	flex-direction: column;
	gap: 20px;
	position: relative;

	@media (min-width: 1280px) {
		flex-direction: row;
		gap: 32px;
	}

	img {
		width: calc(100vw - 40px);
		object-fit: cover;
		object-position: center center;

		@media (min-width: 1280px) {
			width: 380px;
		}
	}

	div {
		display: flex;
		flex-direction: column;
		gap: 20px;
	}
`;

const About = () => {
	const { t } = useTranslation();


	return (
		<>
			<Cover>
				<div className='container'>
					<h1>{t('A Reliable partner in the world of tourism')}</h1>
					<h2>{t('Exceeding your expectations since 1993.')}</h2>
					<h2>{t('We care about every our customer offering a wide range of services at the highest standards.')}</h2>
				</div>
			</Cover>

			<Advantages>
				<div className='container'>
					<h1>{t('Our advantages')}</h1>

					<div>
						<div>
							<img src={richImg} />
							<h3>{t('Rich experience')}</h3>
							<p>{t('Enables to find the best solutions in any circumstances providing services at a constantly high level.')}</p>
						</div>

						<div>
							<img src={reliabilityImg} />
							<h3>{t('Reliability')}</h3>
							<p>{t('We always fulfill our obligations to the clients entirely repaying their trust.')}</p>
						</div>

						<div>
							<img src={competenceImg} />
							<h3>{t('Competence')}</h3>
							<p>{t('Truly professional team ready to meet any non-standard task.')}</p>
						</div>
					</div>
				</div>
			</Advantages>

			<MainText className='container'>
				<img src={mainTextImg} />

				{i18n.language === 'el'
					? <div>
						<p>Η <b>ACADEMSERVICE INTERNATIONAL</b> είναι μια ταξιδιωτική εταιρεία που ιδρύθηκε το 1993 και διαθέτει τεράστια εμπειρία στα διεθνή ταξίδια. Ειδικευόμαστε σε υπηρεσίες υψηλής ποιότητας σε διάφορους τομείς του τουρισμού.</p>
						<p>Οι δραστηριότητές μας περιλαμβάνουν ατομικό τουρισμό, εταιρικά ταξίδια, MICE και VIP εκδρομές. Προσφέρουμε διαμονή σε ξενοδοχεία σε όλο τον κόσμο, μεταφορές, υπηρεσίες διερμηνείας, τροφοδοσία, ξεναγήσεις και οργάνωση συνεδρίων.</p>
						<p>Το πιο σημαντικό για εμάς είναι η ευγνωμοσύνη και η εκτίμηση των πελατών μας που εμπιστεύονται την <b>ACADEMSERVICE INTERNATIONAL</b> για την ξεκούραση τους για σχεδόν 30 χρόνια!</p>
					</div>
					: <div>
						<p><b>ACADEMSERVICE INTERNATIONAL</b> is a travel company founded in 1993 has vast experience in international travel. We specialize on high-quality service in various fields of tourism.</p>
						<p>Our activities include individual tourism, corporate travel, MICE and VIP tours. We offer hotel accommodation throughout the world, transfers, interpreter services, catering, guided tours and organization of conferences.</p>
						<p>The main thing for us is gratitude and appreciation of our customers who trust <b>ACADEMSERVICE INTERNATIONAL</b> their rest for almost 30 years!</p>
					</div>
				}
			</MainText>
		</>
	);
};

export default About;